import React from 'react';
import './Event_about.css';
import close from '../../img/close.svg'

const FAQ = (props) => {
    const state = {
        About_item: [
            {
                text: `Mastering the Steps of the Model Lifecycle Orchestration Journey`,
            },
            {
                text: `Deep dive Time Series(From Theory to Analysis)`,
            },
            {
                text: `A framework for disciplined execution of Data Science projects`,
            },
            {
                text: `Natural Language Processing for Economics and Finance in TensorFlow 2`,
            },
            {
                text: `Data Quality`,
            },
            {
                text: `Data Governance: A modern need for the contemporary world. `,
            },
            {
                text: `Labeling the data- Various Approaches`,
            },
            {
                text: `Decision making in data science`,
            },
            {
                text: `Data Analysis Primer with Numpy`,
            },
            {
                text: `Python with AI`,
            },
            {
                text: `Deep Transfer Learning for Natural Language Processing`,
            },
            {
                text: `Machine Learning for Autonomous Vehicle (AV)`,
            },
            {
                text: `GANs N’ Roses: Understanding Generative Models (workshop)`,
            },
            {
                text: `Lessons From the Field in Building Your MLOps Strategy`,
            },
      ],
    };

    const renderAboutItem = (item, i) => {
        return (
            <div className='about_item'>
                <p>
                    <span className='terminal_tag_name'>print</span>
                    <span className='terminal_bracket'>(</span>
                    "
                    <span className='terminal_text'>{item.text}</span>
                    "
                    <span className='terminal_bracket'>)</span>
                </p>
            </div>
        );
    };

    return (
        <div className="about_wrap">
            <div className="about container">
                <h3 className="about_title">What is this event about</h3>
                <div className="about_blocks">
                    <div className='about_terminal--header'>
                        <div className='about_terminal--tab'>
                            <p className='about_terminal--title'>snake_case.py</p>
                            <img className='about_terminal--img' src={close} alt="" />
                        </div>
                        <div className='about_terminal--tab about_terminal--tab_active'>
                            <p className='about_terminal--title'>event_about.py</p>
                            <img className='about_terminal--img' src={close} alt="" />
                        </div>
                    </div>
                    <div className='about_terminal--body'>
                        {state.About_item.map((item, i) => renderAboutItem(item, i))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FAQ;